import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

/* eslint-disable import/prefer-default-export */
export function updatePromoCode({ dispatch }, params) {
  return http.put(`${MINERVA_API_URL}/promo-codes`, params)
    .then(res => (
      dispatch('setUserLicence', res.data)
    ));
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/app/user-licence/store/actions.js